import React from 'react';

import { Row, Col } from 'antd';
import { Tag, Typography, Space } from 'antd';

import { CrossedContainer } from '../../boxes/components/lifecycle/CrossedContainer';
import { cleanName } from '../helpers/timeLineHelpers';
import CopyToClipboard from '@/components/CopyToClipboard';
import BoxDestroyedIcon from '@/components/icons/BoxDestroyedIcon';
import BoxIcon from '@/components/icons/BoxIcon';
import BoxProIcon from '@/components/icons/BoxProIcon';
import BusinessIcon from '@/components/icons/BusinessIcon';
import EarthIcon from '@/components/icons/EarthIcon';
import { IsolatedIcon } from '@/components/icons/IsolatedIcon';
import TabletIcon from '@/components/icons/TabletIcon';
import { StatusDeletedHeader } from '@/features/boxes/components/lifecycle/StatusDeletedHeader';
import { formatISODate } from '@/helpers/dates';

const iconStyle = {
  width: 80,
  height: 60,
};
const flexCenter = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};
const flexColumnCenter = {
  display: 'flex',
  flexDirection: 'column' as 'column',
  justifyContent: 'center',
};

function IconSelection({ eventType }) {
  switch (eventType) {
    case 'TABLET_IN_STOCK':
    case 'TABLET_IN_QUALITY_PRISON':
    case 'TABLET_REFURBISHED':
      return <TabletIcon />;
    case 'PRODUCT_IN_QUALITY_PRISON':
      return <BoxIcon />;
    case 'PRODUCT_IN_STOCK':
    case 'PRODUCT_IN_REWORK':
      return <BoxProIcon {...iconStyle} />;
    case 'IN_CIRCULATION':
    case 'OUT_OF_CIRCULATION':
      return <EarthIcon {...iconStyle} />;
    case 'IN_BUSINESS':
    case 'OUT_OF_BUSINESS':
    case 'TABLET_DESTROYED':
      return <BusinessIcon {...iconStyle} />;
    case 'PRODUCT_DESTROYED':
      return <BoxDestroyedIcon {...iconStyle} />;
    case 'ISOLATED':
      return <IsolatedIcon {...iconStyle} />;
    default:
      return null;
  }
}

export const TimeLineMainCard = ({
  timeLineEvent,
  isDeletable,
  isDeleted,
  showModal,
}) => (
  <>
    {isDeleted && <StatusDeletedHeader timeLineEvent={timeLineEvent} />}
    <Row style={{ height: '128px' }}>
      <Col span={24}>
        <Row>
          <Col style={{ paddingBottom: '1rem', width: 105 }}>
            <Tag
              bordered={false}
              style={{ fontWeight: 'bold', opacity: isDeleted ? 0.3 : 1 }}
            >
              {formatISODate(timeLineEvent.created_at, 'dd/MM/yyyy - HH:mm:ss')}
            </Tag>
          </Col>
          <Col flex="auto" />
          <Col span={8}>
            <Typography.Text
              style={{
                color: '#808080',
                display: 'flex',
                justifyContent: 'end',
                marginRight: 25,
              }}
            >
              {timeLineEvent.source_type === 'physical_station'
                ? `${timeLineEvent.source_name} / ${timeLineEvent.station_source}`
                : timeLineEvent.station_source}
            </Typography.Text>
          </Col>
        </Row>
      </Col>
      <Col
        span={24}
        style={{
          opacity: isDeleted ? 0.3 : 1,
        }}
      >
        <CrossedContainer isDeleted={isDeleted}>
          <Space
            direction="vertical"
            size={0}
            style={{
              background: '#ffffff',
              border: '1px solid #008379',
              boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
              borderRadius: 10,
              marginRight: 25,
              width: '100%',
            }}
          >
            <Row style={{ height: '100%', padding: '1rem' }}>
              <Col flex="80px" style={{ ...flexCenter, marginRight: '10px' }}>
                <Space style={{ ...flexCenter, height: '100%' }}>
                  <IconSelection eventType={timeLineEvent.status} />
                </Space>
              </Col>
              <Col flex="3 1 0" style={flexColumnCenter}>
                <Typography.Title
                  level={4}
                  style={{
                    fontSize: 20,
                    display: 'flex',
                    alignItems: 'end',
                    height: '100%',
                    margin: 0,
                  }}
                >
                  {cleanName(timeLineEvent.status)}
                </Typography.Title>
                <Space
                  direction="vertical"
                  size={0}
                  style={{ paddingBottom: 10 }}
                >
                  <Typography.Text>
                    {' '}
                    by <b>{timeLineEvent.created_by.email}</b>{' '}
                  </Typography.Text>
                  <Space align="center" size={8}>
                    <Typography.Text>
                      {timeLineEvent.created_by.id}
                    </Typography.Text>
                    <Space style={{ cursor: 'pointer', marginTop: '8px' }}>
                      <CopyToClipboard
                        round
                        data={timeLineEvent.created_by.id}
                      />
                    </Space>
                  </Space>
                </Space>
              </Col>
              <Col flex="80px" style={flexCenter}>
                {isDeletable && (
                  <Typography.Text
                    style={{
                      fontWeight: 700,
                      color: isDeleted ? 'black' : '#38a169',
                      cursor: isDeleted ? 'default' : 'pointer',
                    }}
                    onClick={isDeletable && !isDeleted ? showModal : null}
                  >
                    Cancel
                  </Typography.Text>
                )}
              </Col>
            </Row>
          </Space>
        </CrossedContainer>
      </Col>
    </Row>
  </>
);
